import React from "react";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";


function AdminUsersHint({pendingUsersCount}) {

  if (!pendingUsersCount) return
    return (
      <Alert
        message={`${pendingUsersCount} عدد پروفایل برای بررسی وجود دارد.`}
        type="info"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" type="pramary">
            <Link to="/admin-users?confirmStatus=PENDING">بررسی</Link>
          </Button>
        }
      />
    );
}
    export default AdminUsersHint;